const fb = require('../firebase.js');


    const getNumberProfiles = async()=> {
        return await fb.db.collection("profiles").get().then(snap => snap.size );
}
    const moneyEarned = async()=> {
        const query = await fb.db.collection("ventes").get();
        let resultat = 0;

        query.forEach(async doc => {
           resultat += doc.data().panier.total
        });
        return resultat
    }


module.exports = {
    getNumberProfiles: getNumberProfiles,
    moneyEarned: moneyEarned,
}